<template>
  <Icon
    name="clear"
    :width="20"
    :height="20"
  >
    <path d="M7.19877 17.2802C6.90891 17.2802 6.64321 17.1836 6.42582 16.9662L1.61906 12.1595C1.18427 11.7247 1.18427 11.0483 1.61906 10.6136C2.05384 10.1788 2.73017 10.1788 3.16495 10.6136L7.22292 14.6474L16.8606 5.03385C17.2954 4.59907 17.9717 4.59907 18.4065 5.03385C18.8413 5.46863 18.8413 6.14496 18.4065 6.57975L7.99587 16.9662C7.75432 17.1836 7.48862 17.2802 7.19877 17.2802Z"/>
  </Icon>
</template>

<script>
import Icon from "../Elements/Icon";

export default {
  name: 'Open',
  components: { Icon }
};
</script>

